import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { ProductService } from '../../services/product.service';
import { ProductGroupService } from '../../services/product-group.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-product-group-create',
  standalone: true,
  imports: [FormsModule, CommonModule, NgSelectModule, TranslocoModule],
  templateUrl: './product-group-create.component.html',
  styleUrl: './product-group-create.component.css'
})
export class ProductGroupCreateComponent implements OnInit {
  groupName: string = '';
  selectedProduct: any[] | null = null;
  selectedProducts: any[] = [];
  products: any[] = [];
  productTypeahead$ = new Subject<string>();
  formSubmitted: boolean = false;
  productGroupId: string | null = null;  // Armazena o ID do grupo (se for modo de edição)

  constructor(
    private produtctService: ProductService,
    private productGroupService: ProductGroupService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,  // Injeta ActivatedRoute para pegar parâmetros da rota
    private transloco: TranslocoService
  ) {
    this.productTypeahead$ = new Subject<string>();

    this.productTypeahead$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap(term => this.searchProducts(term))
    ).subscribe((response: any) => {

      let data: [] = response;
      let filteredData = data.filter(product => !this.productAlreadySelected(product));
      this.products = filteredData;
    });
  }

  ngOnInit(): void {
    
    this.route.paramMap.subscribe(params => {
      this.productGroupId = params.get('productGroupId');

      if (this.productGroupId) {
        this.loadProductGroup(this.productGroupId);
      }
    });
  }

  loadProductGroup(productGroupId: string): void {
    this.spinner.show();

    this.productGroupService.getById(productGroupId).subscribe({
      next: (productGroup) => {
        this.groupName = productGroup.name;
        this.selectedProducts = productGroup.products;  // Suponha que o backend devolva os produtos diretamente
        this.spinner.hide();
      },
      error: () => {
        this.toastr.error(this.transloco.translate('productGroup.toast.loadError'));
        this.spinner.hide();
      }
    });
  }

  searchProducts(term: string): Observable<any> {
    if (!term || term.length < 3) {
      return of([]);
    }

    return this.produtctService.get(term)
      .pipe(map(response => response.body));
  }

  addProduct() {
    if (this.selectedProduct) {
      this.selectedProduct.forEach(product => {
        const selected = this.productAlreadySelected(product);
        if (!selected) {
          this.selectedProducts.push(product);
        }
        this.selectedProduct = null;
      });
    }
  }

  productAlreadySelected(product: any): boolean {
    let index = this.selectedProducts.findIndex(x => x.productId == product.productId);
    return index >= 0;
  }

  removeProduct(product: any) {
    this.selectedProducts = this.selectedProducts.filter(p => p !== product);
  }

  save() {
    this.formSubmitted = true;

    if (!this.groupName || this.selectedProducts.length === 0) {
      return;
    }

    const productGroup = {
      name: this.groupName,
      productIds: this.selectedProducts.map(x => x.productId),
      inactive: false
    };

    this.spinner.show();

    if (this.productGroupId) {
      this.saveNew(productGroup);
    } else {
      this.saveExisting(productGroup);
    }
  }


  saveExisting(productGroup: { name: string; productIds: any[]; inactive: boolean; }) {
    this.productGroupService.post(productGroup)
      .subscribe({
        next: () => {
          this.toastr.success(this.transloco.translate('productGroup.toast.created'));
          this.spinner.hide();
          this.router.navigate(['/product-group']);
        },
        error: () => {
          this.toastr.error(this.transloco.translate('productGroup.toast.createError'));
          this.spinner.hide();
        }
      });
  }

  saveNew(productGroup: { name: string; productIds: any[]; inactive: boolean; }) {
    this.productGroupService.update(this.productGroupId, productGroup)
      .subscribe({
        next: () => {
          this.toastr.success(this.transloco.translate('productGroup.toast.updated'));
          this.spinner.hide();
          this.router.navigate(['/product-group']);
        },
        error: () => {
          this.toastr.error(this.transloco.translate('productGroup.toast.updateError'));
          this.spinner.hide();
        }
      });
  }

  cancelar() {
    this.router.navigate(['/product-group']);
  }
}
